import AuthScreenFA from './AuthScreenFA'

export default AuthScreenFA
